import React from "react";

type BadgeVariant =
  | "success"
  | "info"
  | "outline"
  | "success-icon"
  | "info-icon";

type BadgeProps = {
  children: React.ReactNode;
  variant?: BadgeVariant;
  icon?: string;
};

const Badge: React.FC<BadgeProps> = ({ children, variant = "info", icon }) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "success":
        return "text-emerald-700 bg-emerald-50 border border-emerald-200";
      case "success-icon":
        return "text-emerald-700 bg-emerald-50 border border-emerald-200 flex gap-1 items-center";
      case "info":
        return "text-blue-700 bg-sky-50 border border-sky-200";
      case "info-icon":
        return "text-blue-700 bg-sky-50 border border-sky-200 flex gap-1 items-center";
      case "outline":
        return "text-indigo-900 border-2 border-indigo-900";
      default:
        return "text-gray-800 bg-sky-50 border border-sky-200";
    }
  };

  return (
    <span
      className={`py-0.5 px-2.5 rounded-full border-solid ${getVariantClasses()}`}
    >
      {icon && (
        <img
          src={icon}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto w-3 aspect-square"
        />
      )}
      {children}
    </span>
  );
};

export default Badge;
